<template>

  <div class="card-header">

    <p class="card-header-title sc-card__title">
      {{ app.app_name }}
    </p>


    <menu-card :app="app"/>

  </div>

</template>

<script>

import MenuCard from './menu-card/MenuCard.vue';

export default {
  name: 'integrations-self-service-app-card-header',
  components: {
    MenuCard,
  },
  props: {
    app: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {

  .card-header{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    background-color: white;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/app-card/header-card/HeaderCard.vue?3ce726f7